import { createContext, useReducer, useEffect, useState } from "react";
import PropTypes from 'prop-types';
import axios from 'axios';

export const AuthContext = createContext();

export const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { user: action.payload };
        case 'LOGOUT':
            return { user: null };
        default:
            return state;
    }
};

export const AuthContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, {
        user: null,
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUserDetails = async (token) => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/users/me`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                const userDetails = response.data;

                // Dispatch the login action with user details
                dispatch({ type: 'LOGIN', payload: { ...userDetails, token } });
            } catch (error) {
                console.error('Error fetching user details:', error.response || error.message);
            } finally {
                setLoading(false);
            }
        };

        const user = localStorage.getItem('user');
        if (user) {
            const parsedUser = JSON.parse(user);
            if (parsedUser && parsedUser.token) {
                fetchUserDetails(parsedUser.token);
            }
        }
        setLoading(false); // Ensure loading is set to false after checking localStorage
    }, []);

    if (loading) {
        return <div>Loading...</div>; // Show a loading indicator while resolving auth state
    }

    return (
        <AuthContext.Provider value={{ ...state, dispatch, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

AuthContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};